import { useRef as u, useMemo as n } from "react";
import o from "zustand/shallow";
function c(r) {
  const t = u();
  return n(() => {
    const e = t.current;
    return e && o(r, e) ? e : (t.current = r, r);
  }, [r]);
}
export {
  c as default
};
//# sourceMappingURL=useStableOptions.mjs.map
